import { z } from 'zod';

import {
  EntityBaseSchema,
  NonEmptyStringSchema,
  ReferenceSchema,
  StringSchema,
} from '../../base';

// SMS template references schema
export const SmsTemplateReferencesSchema = z.object({
  topics: ReferenceSchema,
  flowSteps: ReferenceSchema,
  variables: ReferenceSchema,
  translations: ReferenceSchema,
});

export type SmsTemplateReferences = z.infer<typeof SmsTemplateReferencesSchema>;

// Environment phone numbers schema
export const EnvPhoneNumbersSchema = z.object({
  sandbox: StringSchema,
  preRelease: StringSchema,
  live: StringSchema,
});

// SMS template metadata schema (updatedAt and updatedBy are required strings, not optional)
export const SmsTemplateMetadataSchema = z.object({
  createdAt: z.string(), // ISO string
  createdBy: z.string(),
  updatedAt: z.string(), // Required string, not optional
  updatedBy: z.string(), // Required string, not optional
});

export type SmsTemplateMetadata = z.infer<typeof SmsTemplateMetadataSchema>;

export const BaseSmsTemplateSchema = z.object({
  name: NonEmptyStringSchema.describe(
    'Template name used to reference this template in functions and rules (e.g., conv.send_sms_template(number, "booking_confirmation"))',
  ),
  text: StringSchema.describe(
    'Message body. Supports substitutions: {{entity:name}}, {{vrbl:VARIABLE-ID}}, {{attr:name}}',
  ),
  active: z.boolean().describe('Whether this SMS template is enabled for use'),
  envPhoneNumbers: EnvPhoneNumbersSchema.describe(
    'Twilio phone numbers used to send this template, per deployment environment',
  ),
  references: SmsTemplateReferencesSchema,
});

// SMS template schema
export const SmsTemplateSchema = EntityBaseSchema.merge(
  BaseSmsTemplateSchema,
).merge(SmsTemplateMetadataSchema);

export type SMSTemplate = z.infer<typeof SmsTemplateSchema>;
